import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllHostsCountWs, selectReadOnly, selectTotalHostsCount } from 'store/Faraday/selectors';
import { RiFileEditLine as EditLine, RiFileDownloadLine as DownloadLine } from 'react-icons/ri';
import ManualCreationModal from 'Screens/Contextualization/ManageEditCreate/components/ManualCreationModal';
import ImportFileCreationModal from 'Screens/Contextualization/ManageEditCreate/components/ImportFileCreationModal';
import useClickOutside from 'Hooks/useClickOutside';
import {
  DropdownText, DropdownItem, Wrapper, DropdownWrapper, PlusIcon, Dropdown
} from './styled';
import { openModal } from 'store/modals/actions';
import { MODAL_CANT_CREATE } from 'store/modals/modals';
import { getWorkspaces } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { selectEmptyActiveWorkspaces } from 'store/Workspace/selectors';

const CreateActions = ({ entity }) => {
  const [showModalCreation, setShowModalCreation] = useState(false);
  const [showModalImport, setShowModalImport] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dispatch = useDispatch();
  const readOnly = useSelector(selectReadOnly);
  const canUpdate = entity === 'vulnsGeneral' || (entity !== 'vulnsGeneral' && !readOnly);
  const assetsCount = useSelector(selectAllHostsCountWs);
  const noAssets = assetsCount === 0;
  const assetsCountAllWorkspaces = useSelector(selectTotalHostsCount);
  const noAssetsFromAllWorkspaces = assetsCountAllWorkspaces === 0;
  const noWorkspaces = useSelector(selectEmptyActiveWorkspaces);

  const dropdownRef = useRef();
  useClickOutside(dropdownRef, () => setShowDropdown(false));

  const handleShow = () => {
    if ((noAssets && (entity === 'vulns')) || ((entity === 'vulnsGeneral') && (noAssetsFromAllWorkspaces || noWorkspaces))) dispatch(openModal(MODAL_CANT_CREATE));
    else setShowModalCreation(true);
    setShowDropdown(false);
  };
  const handleClose = () => setShowModalCreation(false);
  const handleShowImportFromFile = () => {
    setShowModalImport(true);
    setShowDropdown(false);
    dispatch(getWorkspaces(false, false));
  };
  const handleCloseImportFromFile = () => setShowModalImport(false);

  const handleDropdown = () => {
    if (canUpdate || (entity === 'vulnsGeneral')) setShowDropdown(!showDropdown);
  };

  return (
    <Wrapper ref={ dropdownRef }>
      <DropdownWrapper onClick={ handleDropdown } data-tour="Add Vulnerability" disabled={ (entity !== 'vulnsGeneral') && readOnly }>
        <PlusIcon />
        <DropdownText>Add Vulnerability</DropdownText>
      </DropdownWrapper>
      {showDropdown && (
      <Dropdown>
        <DropdownItem onClick={ handleShow } role="button" aria-label="Manual Creation" type="button">
          <EditLine size="1.3em" color="#5a6b7d" />
          Manual Creation
        </DropdownItem>
        <DropdownItem onClick={ handleShowImportFromFile } role="button" aria-label="Import from File" type="button">
          <DownloadLine size="1.3em" color="#5a6b7d" />
          Import from File
        </DropdownItem>
      </Dropdown>
      )}

      { showModalCreation && <ManualCreationModal handleClose={ handleClose } entity={ entity } />}
      <ImportFileCreationModal show={ showModalImport } handleClose={ handleCloseImportFromFile } entity={ entity } />
    </Wrapper>
  );
};

export default CreateActions;
